import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { BankGuaranteeInformationContainer } from './styled'
import { getJobs, getBankOwners, getFinanceUser } from 'ducks/bankGuarantee'

const BankGuaranteeInformation = (props) => {
  const { valueForm={}, change, jobs, bankOwners, 
    financeUser, isDisplay=false, editMode=false } = props
  const [showBankGuaranteeInfo, setShowBankGuaranteeInfo] = useState(true)
  
  const [jobOptions, setJobOptions] = useState([])

  useEffect(() => {
    if (!jobs.data.length && !jobs.loading) {
      props.getBankOwners()
    }

    if (!bankOwners.data.length && !bankOwners.loading) {
      props.getJobs()
    }

    if (!financeUser.data.length && !financeUser.loading) {
      props.getFinanceUser()
    }
  }, [])

  useEffect(() => {
    if (jobs.data.length && !jobOptions.length) {
      setJobOptions(jobs.data)
    }
  }, [jobs])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const onAddNewJob = (job) => {
    setJobOptions([...jobOptions, { value: job, text: job }])
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Bank Guarantee Information'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowBankGuaranteeInfo(!showBankGuaranteeInfo) }>
            {showBankGuaranteeInfo ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showBankGuaranteeInfo}>
        <CardContent>
          <BankGuaranteeInformationContainer>
            <div className='rowFields'>
              <Field 
                name='bankGuaranteeNumber' 
                label='Bank Guarantee No.' 
                require 
                editable={editableForm()} 
                type={type.text} 
                component={FieldInput} />
              <Field 
                name='bankOwner' 
                label='Bank Owner' 
                require
                editable={editableForm() && valueForm.createType === 'original'}
                loading={bankOwners.loading}
                options={bankOwners.data} 
                type={type.select}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <div className='rowFields'>
                <Field 
                  name='startDate' 
                  label='Start Date' 
                  require
                  editable={editableForm()}
                  type={type.date}
                  component={FieldInput} />
                <Field 
                  name='dueDate' 
                  label='Due Date' 
                  editable={editableForm() && valueForm.noExpire === false} 
                  require={valueForm.noExpire === false} 
                  type={type.date} 
                  component={FieldInput} 
                />
              </div>
              {
                valueForm.status === 21 ? // Returned
                  <Field 
                    name='returnedDate' 
                    label='Returned Date'
                    editable={false}
                    type={type.date} 
                    component={FieldInput} /> : 
                  <Field type={type.empty} component={FieldInput} />
              }
            </div>
            <div className='rowFields'>
              <div className='rowFields'>
                <Field type={type.empty} component={FieldInput} />
                <Field 
                  name='noExpire' 
                  label='No Expire Date' 
                  editable={editableForm()}  
                  type={type.checkbox}
                  specialOnChange={(value) => {
                    if (value) {
                      change('dueDate', null)
                    }
                  }}
                  component={FieldInput} 
                />
              </div>
              <Field type={type.empty} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='job' 
                label='Job' 
                require
                options={jobOptions} 
                loading={false} 
                allowAdditions
                onAddNewItem={onAddNewJob}
                editable={editableForm() || editMode}  
                type={type.select} 
                component={FieldInput} 
              />
              <Field type={type.empty} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='location' 
                label='BG Location' 
                require
                options={[
                  { value: 'dtgo', text: 'DTGO' },
                  { value: 'bank', text: 'Bank' }
                ]} 
                horizontalView
                editable={editableForm() || editMode}  
                type={type.radio} 
                component={FieldInput} 
              />
            </div>
            {
              valueForm.location === 'bank' ?
                <React.Fragment>
                  <div className='rowFields'>
                    <Field 
                      name='depositAtBank' 
                      label='Deposit at BANK' 
                      require
                      editable={editableForm() || editMode}
                      loading={bankOwners.loading}
                      options={bankOwners.data} 
                      type={type.select}
                      component={FieldInput} />
                    <Field 
                      name='depositDate' 
                      label='Deposit Date' 
                      require
                      editable={editableForm() || editMode}
                      type={type.date}
                      component={FieldInput} />
                  </div> 
                  <div className='rowFields'>
                    <Field 
                      name='depositor' 
                      label='Depositor'
                      require 
                      editable={editableForm() || editMode}
                      options={financeUser.data}
                      loading={financeUser.loading}
                      type={type.select}
                      component={FieldInput} />
                  </div> 
                  <div className='rowFields'>
                    <Field 
                      name='depositRemark' 
                      label='Remark' 
                      editable={editableForm() || editMode}
                      type={type.textArea}
                      component={FieldInput} />
                  </div> 
                </React.Fragment> : null
            }
          </BankGuaranteeInformationContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    jobs: state.bg.jobs,
    bankOwners: state.bg.bankOwners,
    financeUser: state.bg.financeUser,
  })
}
  
const mapDispatchToProps = {
  getJobs,
  getBankOwners,
  getFinanceUser
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeInformation)